<template>
  <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-person-lines-fill display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            SEGUIMIENTO DE RENOVACION
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTADO DE TRABAJADORES
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <button @click="descargarExcel()" :class="{
        'btn btn-primary mt-2 ms-2': excelCarga,
        'btn btn-outline-primary mt-2 ms-2': !excelCarga,
      }" :disabled="excelCarga">
        <i class="bi bi-filetype-xls"></i>
        <!-- <b v-if="excelCarga"></b>
        <b v-else>CARGANDO...</b> -->
      </button>

      <button @click="CargaMasiva" class="btn btn-success mt-2 ms-2">
        <i class="bi bi-file-pdf"></i>
      </button>

      <button @click="descargarLimpioMasivo" class="btn btn-outline-success mt-2 ms-2" title="Descargar seleccionados (Limpios)">
        <i class="bi bi-file-earmark-arrow-down"></i> <small class="fw-bold">Masivo</small>
      </button>

      <button @click="descargarFirmadoMasivo" class="btn btn-outline-danger mt-2 ms-2" title="Descargar seleccionados (Firmados)">
        <i class="bi bi-file-earmark-pdf"></i> <small class="fw-bold">Masivo</small>
      </button>

      <button
        @click="Dni = '', Apellidos = '', SubSubCentro = '', Ciudad = '', perAno = '0', perMes = '0', busquedaIndividual = false, SeguimientosTools()"
        class="btn btn-info mt-2 ms-2 text-white">
        <i class="bi bi-eraser"></i>
      </button>

      <button @click="BuscarCampaña(0)" class="btn btn-success mt-2 ms-2"><i
          class="bi bi-rocket-takeoff-fill"></i></button>
    </div>

    <div class="mt-2 pb-2">
      <div class="border border-1 rounded-3 p-3 mb-2 ">
        <div class="row g-2 mt-2">

          <!-- DNI -->
          <div class="col-md-3">
            <label class="tamaño fw-bold d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-credit-card-2-front text-primary"></i> DNI
            </label>
            <b-input :disabled="Ciudad.length > 0 || Apellidos.length > 0 || SubSubCentro.length > 0" class="p-2"
              id="searchInput1" v-model="Dni" placeholder="BUSQ. POR DOC. IDENTIDAD" @input="Dni = Dni.replace(/\s+/g, ''), SeguimientosTools()"></b-input>
          </div>

          <!-- Apellidos -->
          <div class="col-md-3">
            <label class="tamaño fw-bold d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-person-lines-fill text-primary"></i> APELLIDOS
            </label>
            <b-input :disabled="Dni.length > 0 || SubSubCentro.length > 0 || Ciudad.length > 0" class="p-2"
              id="searchInput2" v-model="Apellidos" placeholder="BUSQ. POR APELLIDOS" @input="Apellidos = Apellidos.replace(/^\s+/, '')"></b-input>
          </div>

          <!-- Cliente -->
          <div class="col-md-3">
            <label class="tamaño fw-bold d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-buildings text-primary"></i> CANAL
            </label>
            <b-input :disabled="Dni.length > 0 || Apellidos.length > 0 || Ciudad.length > 0" class="p-2"
              id="searchInput3" v-model="SubSubCentro" placeholder="BUSQ. POR CANAL" @input="SubSubCentro = SubSubCentro.replace(/^\s+/, '')"></b-input>
          </div>

          <!-- Ciudad -->
          <div class="col-md-3">
            <label class="tamaño fw-bold d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-geo-alt text-primary"></i> CIUDAD
            </label>
            <b-input :disabled="Dni.length > 0 || Apellidos.length > 0 || SubSubCentro.length > 0" class="p-2"
              id="searchInput4" v-model="Ciudad" placeholder="BUSQ. POR CIUDAD" @input="Ciudad = Ciudad.replace(/^\s+/, '')"></b-input>
          </div>

          <!-- Año -->
          <div class="col-md-3">
            <label class="tamaño fw-bold d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-calendar-event text-success"></i> AÑO
            </label>
            <select v-model="perAno" @change="SeguimientosTools()" class="form-select p-2 w-100">
              <option disabled selected value="0">-- SELECCIONAR AÑO --</option>
              <option v-for="año in años" :key="año.value" :value="año.value">
                {{ año.label }}
              </option>
            </select>

          </div>

          <!-- Mes -->
          <div class="col-md-3">
            <label class="tamaño fw-bold d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-calendar-month text-warning"></i> MES
            </label>
            <select v-model="perMes" @change="perMes = $event.target.value, reporte(), SeguimientosTools()"
              class="form-select p-2 w-100">
              <option disabled selected value="0">-- SELECCIONAR MES --</option>
              <option v-for="mes in meses" :key="mes.value" :value="mes.value">
                {{ mes.label }}
              </option>
            </select>
          </div>

          <div class="col-md-2 d-flex align-items-end justify-content-center">
            <div class="mb-2">
              <input :disabled="Ciudad.length > 0 || Apellidos.length > 0 || SubSubCentro.length > 0" class="form-check-input me-1" type="checkbox" v-model="busquedaIndividual" @change="SeguimientosTools()" /> Búsqueda Individual 
            </div>
          </div>
          
        </div>
      </div>

      <!-- <div class="border border-1 rounded-3 p-3 mb-2"> -->
        <!-- <label class="">{{ chartTitle }}</label> -->
        <!-- <div class="small-doughnut-container">
          <Doughnut :options="chartOptions" :data="chartData" />
        </div>
      </div> -->
    </div>

    <div class="modal" v-if="showModal">
      <div class="modal-content" @mouseleave="closeModal">
        <div class="row">
          <div class="col-7 gx-0">
            <div class="px-3 mt-2 d-flex flex-column align-items-start" v-for="usu in usuarioIndividual" :key="usu.id">
              <p>
                <strong class="label-column"> Periodo:</strong>
                <label>{{ usu.periodo }}</label>
              </p>
              <p>
                <strong class="label-column">Ruc:</strong><label> {{ usu.ruc }}</label>
              </p>
              <p>
                <strong class="label-column">Razon Social:</strong><label>{{ usu.nomLargoEmp }}</label>
              </p>
              <p>
                <strong class="label-column">SCC:</strong>
                <label>{{ usu.subCentroCostos }}</label>
              </p>

              <p>
                <strong class="label-column">SSCC:</strong>
                <label>{{ usu.subSubCentroCostos }}</label>
              </p>

              <p>
                <strong class="label-column"> Dirección: </strong>
                <label>{{ usu.direccion }}</label>
              </p>
            </div>
          </div>

          <div class="col-5 gx-0">
            <div class="mt-2 d-flex flex-column align-items-start" v-for="usu in usuarioIndividual" :key="usu.id">
              <p>
                <strong class="label-column"> Estado:</strong>
                <label>{{ usu.renCodEstado }}</label>
              </p>

              <p>
                <strong class="label-column">N° Documento:</strong>
                {{ usu.nroDocumento }}
              </p>
              <p>
                <strong class="label-column">Apellidos y nombres:</strong>
                {{ usu.nomTrabajador }}
              </p>

              <p>
                <strong class="label-column"> Ciudad: </strong>
                {{ usu.departamento }}
              </p>
            </div>
          </div>
        </div>

        <div class="mx-5 mt-2">
          <div class="row gy-3 mx-5">
            <div class="col-6">
              <h5><strong>Valores actuales</strong></h5>
            </div>
            <div class="col-6">
              <h5><strong> Valores posteriores a la renovación</strong></h5>
            </div>

            <div class="col-5 gx-0">
              <div class="mt-2 px-3 d-flex flex-column align-items-start" v-for="usu in usuarioIndividual"
                :key="usu.id">
                <p>
                  <strong class="label-column">Sueldo Actual: </strong>
                  <label> {{ usu.renSueldoActual }}</label>
                </p>

                <p>
                  <strong class="label-column">Fecha ini. actual:</strong>
                  <input class="border border-2 ms-2 rounded text-center" type="date"
                    :value="usu.fecIniConActual.slice(0, 10)" name="" id="" />
                </p>
                <p>
                  <strong class="label-column">Fecha fin actual:</strong>

                  <input class="border border-2 ms-2 rounded text-center" type="date" name=""
                    :value="usu.fecFinConActual.slice(0, 10)" id="" />
                </p>
                <p>
                  <strong class="label-column">Puesto:</strong>
                  {{ usu.nomPuesto }}
                </p>
              </div>
            </div>

            <div class="col-2 py-0 d-flex justify-content-center">
              <div class="bg-dark" style="width: 3px; height: 100%; margin: 0; padding: 0"></div>
            </div>

            <div class="col-5 gx-0">
              <div class="mt-2 px-3 d-flex flex-column align-items-start" v-for="usu in usuarioIndividual"
                :key="usu.id">
                <p>
                  <strong class="label-column">Sueldo: </strong>
                  {{ usu.renSueldo }}
                </p>
                <p>
                  <strong class="label-column">Fecha ini. contrato:</strong>
                  <input class="border border-2 rounded text-center" type="date" name=""
                    :value="usu.fechaIniContrato.slice(0, 10)" id="" />
                </p>
                <p>
                  <strong class="label-column">Fecha fin contrato:</strong>
                  <input class="border border-2 rounded text-center" type="date"
                    :value="usu.fechaFinContrato.slice(0, 10)" name="" id="" />
                </p>

                <p>
                  <strong class="label-column">PuestoNuevo:</strong>
                  {{ usu.nomPuestoNuevo }}
                </p>
              </div>
            </div>

            <div class="col-6" v-for="usu in usuarioIndividual" :key="usu.id">
              <p>
                <strong>Días antes de la renovación: </strong>
                {{ usu.diasRen }}
              </p>
            </div>

            <div class="col-6" v-for="usu in usuarioIndividual" :key="usu.id">
              <p>
                <strong>Record de Trabajador: </strong>
                {{ usu.diasTrabajador }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-5 gx-0">
          <div class="mt-2 d-flex flex-column align-items-start">
            <button @click="cerrar" class="btn btn-danger">cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3 mx-2">
  <div class="d-flex align-items-center px-3 py-2 bg-primary bg-opacity-10 border border-primary rounded-3 shadow-sm">
    <i class="bi bi-people-fill text-primary fs-5 me-2"></i>
    <span class="fw-bold text-primary">
     Total de trabajadores: {{ itemsFiltrados.length }}
    </span>
  </div>
</div>

      <div class="d-flex justify-content-between ms-3">
        <svg @click="off = !off" xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" :class="{
          'bi-toggle-off': off,
          'bi-toggle-on': !off,
          'toggle-transition': true,
        }" viewBox="0 0 16 16">
          <path :class="{ 'toggle-transition text-secondary': true }" v-if="off"
            d="M11 4a4 4 0 0 1 0 8H8a4.992 4.992 0 0 0 2-4 4.992 4.992 0 0 0-2-4h3zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
          <path :class="{ 'toggle-transition text-success': true }" v-else
            d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z" />
        </svg>
      </div>



      <div class="table-responsive mx-2 mt-2">
    
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th scope="col" title="Seleccionar/Deseleccionar todos">
                <input type="checkbox" @change="toggleAll($event)" />
              </th>
              <th scope="col"><i class="bi bi-boxes"></i></th>
              <th scope="col">ESTADO</th>
              <th scope="col">CIUDAD</th>
              <th scope="col">TRABAJADOR</th>
              <th scope="col">CLIENTE</th>
              <th scope="col">CONTRATO ACTUAL</th>
              <th scope="col">NUEVO CONTRATO</th>
              <!-- <th v-if="off" scope="col">VCTO. DE CONTRATO</th> -->
              <!-- <th v-if="off" scope="col">DIAS TRABAJADOR</th> -->
              <th v-if="off" scope="col">RECORD TRABAJADORES</th>
            </tr>
          </thead>
          <tbody class="align-middle">
            <tr :class="{ 'disabled-row': itema.diasTrabajador > 1260 }" class="text-center align-middle reducirTamaño"
              v-for="itema in itemsPaginados" :key="itema.id">
              <td class="text-center">
                <input type="checkbox" v-model="itema.sel" />
              </td>
              <td scope="row" class="text-center tabla-estiloCompreso">
                <div class="d-flex">
                  <button v-if="!off" class="btn btn-outline-primary boton-estiloCuadrado"
                    @click="openModal(itema.idRenovacion)">
                    <i class="bi bi-eye-fill"></i>
                  </button>
                  <button v-if="itema.estadoPdf == true" @click="DescargarPdf(itema)" target="_blank"
                    class="btn boton-estiloCuadrado btn-success" :class="{
                      'btn btn-success': itema.estadoPdf,
                      'btn btn-outline-success': !itema.estadoPdf,
                    }">
                    <i class="bi bi-file-earmark"></i>
                  </button>

                  <button v-else target="_blank" class="btn boton-estiloCuadrado" :class="{
                    'btn btn-success': itema.estadoPdf,
                    'btn btn-outline-success': !itema.estadoPdf,
                  }">
                    <i class="bi bi-file-earmark"></i>
                  </button>

                  <button v-if="itema.renCodEstado !== 'RENOVADO'" class="btn btn-outline-danger boton-estiloCuadrado">
                    <i class="bi bi-file-earmark-pdf"></i>
                  </button>
                  <button v-if="itema.renCodEstado == 'RENOVADO'"
                    class="btn btn-danger text-white boton-estiloCuadrado">
                    <a :href="url + itema.renAdjunto.split('Legajo\\')[1]" target="_blank" class="text-white">
                      <i class="bi bi-file-earmark-pdf"></i></a>
                  </button>
                </div>
              </td>

              <td class="text-start fw-bold">

                <label>{{ itema.periodo }}</label><br />
                <label for="" :class="{
                  'text-primary': itema.renCodEstado == 'EN PROCESO',
                  'text-warning': itema.renCodEstado == 'SOLICITADO',
                  'text-success': itema.renCodEstado == 'RENOVADO',
                  'text-danger': itema.renCodEstado == 'NO RENOVADO',
                }">{{ itema.renCodEstado }}</label>
              </td>

              <td class="text-center">{{ itema.departamento }}</td>

              <td class="text-start fw-bold">
                <label class="">{{ itema.nroDocumento }}</label> <br />
                <label class="">{{ itema.nomTrabajador }}</label>
              </td>

              <td class="text-start">
                <label class="">{{ itema.nomEmpresa }}</label><br />
                <label class="text-nowrap ">
                  {{ itema.subCentroCostos }}
                  <strong v-if="itema.campana == 'CAMPAÑA'" class="text-danger">
                    ** {{ itema.campana }} **
                  </strong> </label><br /> <label for="" class="">{{ itema.subSubCentroCostos }}</label>
              </td>

              <td class="text-center">
                <label>{{ itema.nomPuesto }}</label><br />
                <label>
                  {{
                    new Date(itema.fecIniConActual).toLocaleDateString("es-ES")
                  }}
                </label>
                -
                <label>
                  {{
                    new Date(itema.fecFinConActual).toLocaleDateString("es-ES")
                  }} </label><br />
                <label>SUELDO ACTUAL: {{ itema.renSueldoActual }}</label>
              </td>

              <td class="text-center text-success fw-bold">
                <label>{{ itema.nomPuestoNuevo }}</label><br />
                <label>
                  {{
                    new Date(itema.fechaIniContrato).toLocaleDateString("es-ES")
                  }}
                </label>
                -
                <label>
                  {{
                    new Date(itema.fechaFinContrato).toLocaleDateString("es-ES")
                  }} </label><br />
                <label>NUEVO SUELDO: {{ itema.renSueldo }}</label>
              </td>

              <!-- <td v-if="off" class="text-center">
                <div class="text-center fw-bold">
                  <label :class="{
                    'text-danger': itema.diasRen < 10,
                    'text-center': true,
                  }">En {{ itema.diasRen }} Dias</label>
                </div>
              </td> -->

              <!-- <td v-if="off" class="text-center fw-bold">
                {{ itema.diasTrabajador }}
              </td> -->

              <td v-if="off" class="align-middle text-center">
                <div class="form-group w-auto d-flex align-items-center">
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoAño.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoAño.slice(0, 1) == 1">
                    {{ itema.formatoAño }} año
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoAño.slice(0, 1) != 1 &&
                    itema.formatoAño.slice(0, 1) != 0
                  ">
                    {{ itema.formatoAño }} años
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoMes.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoMes.slice(0, 1) == 1">
                    {{ itema.formatoMes }} mes
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoMes.slice(0, 1) != 1 &&
                    itema.formatoMes.slice(0, 1) != 0
                  ">
                    {{ itema.formatoMes }} meses
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoDias.slice(0, 1) == 0"></p>
                  <p class="mx-1 mb-0 fw-bold" v-if="itema.formatoDias.slice(0, 1) == 1">
                    {{ itema.formatoDias }} dias
                  </p>
                  <p class="mx-1 mb-0 fw-bold" v-if="
                    itema.formatoDias.slice(0, 1) != 1 &&
                    itema.formatoDias.slice(0, 1) != 0
                  ">
                    {{ itema.formatoDias }} dias
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="loading" class="d-flex justify-content-center mt-4">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
        
          <button class="btn btn-outline-primary btn-sm" @click="irInicio" :disabled="pag === 1">
            <i class=" bi bi-chevron-double-left"></i>
          </button>

         
          <button class="btn btn-outline-primary btn-sm" @click="retroceso" :disabled="noRetroceder || pag === 1">
            <i class="bi bi-chevron-left"></i>
          </button>

       
          <span class="pagination-info small px-2">
            Página {{ pag }} de {{ totalPaginas }}
          </span>

         
          <button class="btn btn-outline-primary btn-sm" @click="aumentar" :disabled="noAvanzar || pag === totalPaginas">
            <i class="bi bi-chevron-right"></i>
          </button>

       
          <button class="btn btn-outline-primary btn-sm" @click="irFinal" :disabled="pag === totalPaginas">
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>

      </div>
    </div>

</template>

<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
// import { Doughnut } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement);
export default {
  name: "SolimanologSeguimientoDeRenovacion",
  // components: { Doughnut },

  data() {
    return {
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Legajo/",
      // url: "https://apitopas.gruposolimano.com.pe/Documentos/Renovacion/",
      // Dni: "0",
      Dni: "",
      Apellidos: "",
      Ciudad: "",
      SubSubCentro: "",
      loading: false,

      idTrabajador: "",
      perPage: 61,
      totalRows: 1,
      currentPage: 1,
      dniUsuario: "",
      filter: "",
      excelCarga: true,
      excel: [],
      Items: [],
      checkeId: [],
      pdfMasivo: [],
      filtradoAntes: "",
      idSeguimiento: [],
      sueldoFinal: 0,
      from: {
        idRenovacion: "",
      },
      isdisabled: false,
      isdisabled2: false,
      primeraTabla: true,
      segundaTabla: false,
      documentos: [],

      pdfMasivos: null,
      pdfMasivoFirmados: null,

      estados: [],

      chartOptions: {
        plugins: {
          legend: {
            display: true,
            position: "right", // Leyenda al costado
          },
          title: {
            display: true,
            text: "CANTIDAD DE REGISTROS POR ESTADO",
            font: {
              size: 20,
              weight: "bold",
            },
            padding: {
              top: 5,
              bottom: 5,
            },
            color: "#333",
          },
        },
        responsive: true,
        // maintainAspec  tRatio: false, // Evita el mantenimiento del aspecto
      },

      showModal: false,
      off: true,
      usuarioIndividual: [],

      pag: 1,
      pagFiltro: 1,
      NUM_RESULTS: 25,
      NUM_RESULTS1: 25,
      NUM_RESULTSFILTRO: 25,
      retroceder: "<<",
      avanzar: ">>",
      noAvanzar: false,
      noRetroceder: false,
      perAno: "0",
      perMes: "0",
      meses: [
        { value: "01", label: "Enero" },
        { value: "02", label: "Febrero" },
        { value: "03", label: "Marzo" },
        { value: "04", label: "Abril" },
        { value: "05", label: "Mayo" },
        { value: "06", label: "Junio" },
        { value: "07", label: "Julio" },
        { value: "08", label: "Agosto" },
        { value: "09", label: "Septiembre" },
        { value: "10", label: "Octubre" },
        { value: "11", label: "Noviembre" },
        { value: "12", label: "Diciembre" },
      ],
      busquedaIndividual: false,
    };
  },

  mounted() {
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");

    this.axios.get("ParametroData/Parametro/7634").then((r) => {
      console.log(r.data);
      this.motivo = r.data;
    });

    this.axios.get("PuestoData/ListadoPuesto").then((r) => {
      console.log(r.data);
      this.puesto = r.data;
    });
  },

  created() {
    // this.Renovaciones()
    this.estadoGrafico(), this.SeguimientosTools();
    this.cambiarEstadoNavbar(); this.reporte()
  },

  computed: {
     años() {
    const inicio = 2022; // año desde donde quieres empezar
    const actual = new Date().getFullYear();

    return Array.from(
      { length: actual - inicio + 1 },
      (_, i) => {
        const year = inicio + i;
        return {
          value: year.toString(),
          label: year.toString()
        };
      }
    );
  },
    fechaDeahora() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${day}-${month}-${year}`;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },

    chartData() {
      const arreglo = [];
      const cantidades = [];
      //  const labels = Object.values(this.estados);
      // const data = Object.values(this.estados);
      this.estados.map((r) => {
        arreglo.push(r.renCodEstado);
        cantidades.push(r.cantidadEst);

        console.log(cantidades);
      });

      const labels = arreglo;

      const datasets = [
        {
          data: cantidades, // Aquí usamos el arreglo de cantidades
          backgroundColor: ["#4CAF50", "#FF6384", "#36A2EB", "#FFCE56"],
        },
      ];
      return {
        labels,
        datasets,
      };
    },

    ...mapGetters("users", ["DniEmpre"]),

    itemsFiltrados() {
      return this.Items.filter(item => {
        const dni = this.Dni.toLowerCase();
        
        // Dividimos lo escrito en palabras para buscar por coincidencia múltiple
        const apellidosInput = this.Apellidos.toLowerCase().trim();
        const palabrasBusqueda = apellidosInput.split(/\s+/);

        const ciudad = this.Ciudad.toLowerCase();
        const subCentro = this.SubSubCentro.toLowerCase();
        
        return (
          (!dni || (item.nroDocumento && item.nroDocumento.toLowerCase().includes(dni))) &&
          (!apellidosInput || (item.nomTrabajador && palabrasBusqueda.every(palabra => item.nomTrabajador.toLowerCase().includes(palabra)))) &&
          (!ciudad || (item.departamento && item.departamento.toLowerCase().includes(ciudad))) &&
          (!subCentro || (item.subSubCentroCostos && item.subSubCentroCostos.toLowerCase().includes(subCentro)))
        );
      });
    },
    
    itemsPaginados() {
      return this.itemsFiltrados.slice(this.NUM_RESULTS - 25, this.NUM_RESULTS);
      // const start = (this.pag - 1) * this.perPage;
      // return this.itemsFiltrados.slice(start, start + this.perPage);
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.itemsFiltrados.length / 25));
    },
    // ...mapGetters("renovaciones", ["Items"]),
  },
  
  watch: {
    Dni() { this.resetPagina(); },
    Apellidos() { this.resetPagina(); },
    Ciudad() { this.resetPagina(); },
    SubSubCentro() { this.resetPagina(); },
  },

  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    openModal(url) {
      console.log(url);

      this.axios.get(`Renovacion/Renovacionxid/${url}`).then((r) => {
        console.log(r.data);
        this.showModal = true;

        this.usuarioIndividual = r.data;
      });
    },

    closeModal() {
      this.showModal = false;
      this.usuarioIndividual = [];
    },

    cerrar() {
      this.showModal = false;
    },

    SeguimientosTools() {
      this.loading = true;
      this.idTrabajador = localStorage.getItem("idTrabajdor");
      this.Items = []
      this.segundaTabla = false
      this.primeraTabla = true
      this.axios
        .get(`Renovacion/SeguimientoRen`, {
          params: {
            idTrabajador: this.idTrabajador,
            perAno: this.perAno,
            perMes: this.perMes,
            busquedaIndividual: this.busquedaIndividual,
            // dni:this.Dni
            dni: this.Dni || "0"
          },
        })
        .then((r) => {
          console.log('lista de seguimientos', r.data);
          this.loading = false;
          this.Items = r.data.map(item => ({
            ...item,
            sel: false // Ahora solo hay una propiedad de selección por ítem
          }));
          this.totalRows = this.Items.length;
          this.resetPagina();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    estadoGrafico() {
      this.axios
        .get(
          `Renovacion/SeguimientoEstadosRen?idTrabajador=${localStorage.getItem(
            "idTrabajdor"
          )}`
        )
        .then((r) => {
          console.log(r.data);
          this.estados = r.data;
        });
    },

    reporte() {
      this.excelCarga = true
      this.axios
        .get(
          `ReportesExcel/ReporteRenovaciones`, {
          params: {
            idTrabajador: this.idTrabajador,
            perAno: this.perAno,
            perMes: this.perMes,
          },
          responseType: "blob"
        }).then((response) => {
          this.excelCarga = false;
          this.excel = response.data;
          console.log(response.data);
        });
    },

    descargarExcel() {
      var fileURL = window.URL.createObjectURL(new Blob([this.excel]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "ReporteRenovaciones.xlsx");
      document.body.appendChild(fileLink);

      fileLink.click();
    },

    BuscarCampaña(entrada) {
      this.Items = []
      this.axios.get(`Renovacion/BusquedaCamapana`, {
        params: {
          idTrabajador: this.idTrabajador,
          perAno: this.perAno,
          perMes: this.perMes,
          renEstado: entrada
        },
      }).then(r => {
        console.log(r.data)
        this.Items = r.data
      })
    },

    async DescargarPdf(items, isBulk = false) {
      console.log(items);

      for (let index of this.Items) {
        if (
          items.idPuesto === index.idPuestoNuevo &&
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual == index.renSueldo &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("no cambia nada");
          console.log(index);
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          await this.axios
            .get(
              `/Renovacion/GenerarPdf?nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.fechaIniContratos}&FechaFinContrato=${items.fechaFinContratos}&FechaIniContratoActual=${items.fechaInicioLaboral}&FechaFinContratoActual=${items.nomFechaFinContrato}&SubSubCentro=${items.subSubCentroCostos}&idEmpresa=${items.idEmpresa}&idTrabajador=${items.idTrabajador}`,
              { responseType: "blob" }
            )
            .then((r) => {
              // this.pdf = r.data;
              // console.log(r);
              // if (r.status == 200) {
              //   this.GenerarPdf();
              // }
              this.pdf = r;
              console.log(r);
              let nombreTrabajador = items.nomTrabajador.replace(/ /g, "_");
              let fecha = items.nomFechaIniContrato.replace(/\//g, "-");
              let filename = `${items.numeroDoc}_${nombreTrabajador}_${fecha}`;
              if (r.status === 200) {
                if (!isBulk) Swal.fire(`Se generó el documento`, "", "success");

                // ✅ Llamar a la función y pasar el nombre real
                this.GenerarPdf(filename, r.data);
              }
            });
        } else if (
          items.idTrabajador === index.idTrabajador &&
          index.renSueldoActual != index.renSueldo &&
          items.idPuesto === index.idPuestoNuevo &&
          index.idRenovacion == items.idRenovacion &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("si cambia sueldo");
          console.log(items);
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          await this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.fechaIniContratos}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaInicioLaboral}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}&idEmpresa=${items.idEmpresa}&idTrabajador=${items.idTrabajador}`,
              { responseType: "blob" }
            )
            .then((r) => {
              // this.pdf = r.data;
              // console.log("hola mundo");
              // if (r.status == 200) {
              //   this.GenerarPdf();
              // }
              this.pdf = r;
              console.log(r);
              let nombreTrabajador = items.nomTrabajador.replace(/ /g, "_");
              let fecha = items.nomFechaIniContrato.replace(/\//g, "-");
              let filename = `${items.numeroDoc}_${nombreTrabajador}_${fecha}`;
              if (r.status === 200) {
                if (!isBulk) Swal.fire(`Se generó el documento`, "", "success");

                // ✅ Llamar a la función y pasar el nombre real
                this.GenerarPdf(filename, r.data);
              }
            });
        } else if (
          items.idPuesto != index.idPuestoNuevo &&
          items.idTrabajador == index.idTrabajador &&
          index.renSueldoActual === index.renSueldo &&
          index.idRenovacion == items.idRenovacion &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("si cambia puesto");
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          await this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.fechaIniContratos}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaInicioLaboral}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}&nroDni=${items.numeroDoc}&idEmpresa=${items.idEmpresa}&idTrabajador=${items.idTrabajador}`,
              { responseType: "blob" }
            )
            .then((r) => {
              // this.pdf = r.data;
              // console.log("hola mundo");
              // if (r.status == 200) {
              //   this.GenerarPdf();
              // }
              this.pdf = r;
              console.log(r);
              let nombreTrabajador = items.nomTrabajador.replace(/ /g, "_");
              let fecha = items.nomFechaIniContrato.replace(/\//g, "-");
              let filename = `${items.numeroDoc}_${nombreTrabajador}_${fecha}`;
              if (r.status === 200) {
                if (!isBulk) Swal.fire(`Se generó el documento`, "", "success");

                // ✅ Llamar a la función y pasar el nombre real
                this.GenerarPdf(filename, r.data);
              }
            });
        } else if (
          items.idPuesto != index.idPuestoNuevo &&
          items.idTrabajador == index.idTrabajador &&
          index.renSueldoActual != index.renSueldo &&
          index.idRenovacion == items.idRenovacion &&
          index.idRenovacion == items.idRenovacion
        ) {
          console.log("si cambian los dos");
          const nomEmpresa = encodeURIComponent(items.nomLargoEmp);

          await this.axios
            .get(
              `Renovacion/GenerarAdenda?nomEmpresa=${nomEmpresa}&ruc=${items.ruc}&representante=${items.nomRepresent}&dniRepre=${items.nroDocumentRepresent}&NomTrabajador=${items.nomTrabajador}&dniTrabajador=${items.nroDocumento}&FechaIniContrato=${items.fechaIniContratos}&FechaFinContrato=${items.fechaFinContratos}&nomPuestoNuevo=${items.nomPuestoNuevo}&Sueldo=${items.renSueldo}&domicilio=${items.direccion}&FechaIniContratoActual=${items.fechaInicioLaboral}&FechaFinContratoActual=${items.nomFechaFinContrato}&nomPuestoAntiguo=${items.nomPuesto}&SubSubCentro=${items.subSubCentroCostos}nroDni=${items.numeroDoc}&idEmpresa=${items.idEmpresa}&idTrabajador=${items.idTrabajador}`,
              { responseType: "blob" }
            )
            .then((r) => {
              // this.pdf = r.data;
              // console.log("hola mundo");
              // if (r.status == 200) {
              //   this.GenerarPdf();
              // }
              this.pdf = r;
              console.log(r);
              let nombreTrabajador = items.nomTrabajador.replace(/ /g, "_");
              let fecha = items.nomFechaIniContrato.replace(/\//g, "-");
              let filename = `${items.numeroDoc}_${nombreTrabajador}_${fecha}`;
              if (r.status === 200) {
                if (!isBulk) Swal.fire(`Se generó el documento`, "", "success");

                // ✅ Llamar a la función y pasar el nombre real
                this.GenerarPdf(filename, r.data);
              }
            });
        }
      }
    },

    toggleAll(event) { // Función única para seleccionar/deseleccionar todos
      const isChecked = event.target.checked;
      this.itemsFiltrados.forEach(item => {
        item.sel = isChecked;
      });
    },

    async descargarLimpioMasivo() {
      // Filtra los ítems seleccionados que además tienen un PDF limpio disponible
      const seleccionados = this.Items.filter(i => i.sel && i.estadoPdf);
      const total = seleccionados.length;
      if (total === 0) {
        return Swal.fire("Atención", "No hay registros seleccionados con PDF limpio disponible", "warning");
      }

      Swal.fire({
        title: 'Descargando Limpios...',
        text: `Iniciando descarga de ${total} archivos...`,
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); }
      });

      for (let i = 0; i < total; i++) {
        // Actualizamos el progreso en el modal: 1/300, 2/300...
        Swal.update({ text: `Descargando: ${i + 1} / ${total}`, showConfirmButton: false });
        await this.DescargarPdf(seleccionados[i], true);
        // Pequeño delay para que el navegador no bloquee múltiples descargas
        await new Promise(resolve => setTimeout(resolve, 800));
      }
      Swal.fire("Finalizado", "Se han procesado las descargas", "success");
    },

    async descargarFirmadoMasivo() {
      // Filtra los ítems seleccionados que además están en estado 'RENOVADO'
      const seleccionados = this.Items.filter(i => i.sel && i.renCodEstado === 'RENOVADO');
      const total = seleccionados.length;
      if (total === 0) return Swal.fire("Atención", "No hay registros seleccionados con PDF firmado disponible", "warning");

      Swal.fire({
        title: 'Descargando Firmados...',
        text: `Iniciando descarga de ${total} archivos...`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => { Swal.showLoading(); }
      });

      for (let i = 0; i < total; i++) {
        // Actualizamos el progreso en el modal: 1/300, 2/300...
        Swal.update({ text: `Descargando: ${i + 1} / ${total}`, showConfirmButton: false });
        await this.descargarArchivoFirmado(seleccionados[i], true); // Pasar true para indicar que es una descarga masiva
        // Pequeño delay para no saturar al navegador
        await new Promise(resolve => setTimeout(resolve, 800));
      }
      Swal.fire("Finalizado", "Se han procesado las descargas firmadas", "success");
    },

    async descargarArchivoFirmado(item, isBulk = false) {
      try {
        const response = await this.axios.get(`Renovacion/DescargarPdfFirmado`, {
          params: { idRenovacion: item.idRenovacion, nroDni: item.numeroDoc },
          responseType: 'blob'
        });

        const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = urlBlob;
        let nombreTrabajador = item.nomTrabajador.replace(/ /g, "_");
        let fecha = item.nomFechaIniContrato.replace(/\//g, "-");
        let filename = `${item.numeroDoc}_${nombreTrabajador}_${fecha}`;
        link.setAttribute('download', `${filename}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Error al descargar el archivo firmado:", error);
        if (!isBulk) Swal.fire("Error", "No se pudo encontrar o descargar el archivo firmado.", "error");
      }
    },

    GenerarPdf(filename, blobData) {
      // Usamos el blobData pasado para evitar problemas de concurrencia en descargas masivas
      var dataToUse = blobData || this.pdf.data;
      var fileURL = window.URL.createObjectURL(new Blob([dataToUse]));
      var fileLink = document.createElement("a");

      console.log(filename);
      fileLink.href = fileURL;
      fileLink.setAttribute("download", `${filename}.pdf`);
      document.body.appendChild(fileLink);
      fileLink.click();
    },

    CargaMasiva() {
      let contadorFinalDePdf = 0;
      let idnomTrabajador = {};

      for (let index of this.documentos) {
        if (index.renCodEstado == "RENOVADO") {
          console.log(index);

          if (
            !(index.nomTrabajador in idnomTrabajador) ||
            index.idRen > idnomTrabajador[index.nomTrabajador]
          ) {
            idnomTrabajador[index.nomTrabajador] = index.idRen;
          }
          // console.log(idnomTrabajador)

          // this.axios
          //   .get(`Renovacion/GuardarPdfMasivo?idRenovacion=${index.idRen}`)
          //   .then((r) => {
          //     console.log(r.data);
          //     contadorFinalDePdf += 1;
          //     if (
          //       r.data == true &&
          //       contadorFinalDePdf == this.checkeId.length
          //     ) {
          //       Swal.fire("Guardado", "", "success");
          //       console.log("recien aplico la alerta", contadorFinalDePdf);
          //     }
          //   });
        }
      }

      // Enviar solicitud a la API usando los últimos IDs
      for (let nombreTrabajador in idnomTrabajador) {
        const idRenovacion = idnomTrabajador[nombreTrabajador];
        console.log(idRenovacion);
        if (!this.checkeId.includes(idRenovacion)) {
          this.checkeId.push(idRenovacion);
        }
        this.axios
          .get(`Renovacion/GuardarPdfMasivo?idRenovacion=${idRenovacion}`)
          .then((r) => {
            console.log(r.data);
            contadorFinalDePdf += 1;

            if (
              r.data === true &&
              contadorFinalDePdf === this.checkeId.length
            ) {
              Swal.fire("Guardado", "", "success");
              console.log("Recién aplicó la alerta", contadorFinalDePdf);
              console.log(
                "Últimos IDs por nombre:",
                idnomTrabajador[nombreTrabajador]
              );
            }
          });
      }

      this.CrearPdfMasivo();
    },

    CrearPdfMasivo() {
      this.axios
        .get(`RenMasivo/GenerarPdfMasivo/${this.checkeId}`, {
          responseType: "blob",
        })
        .then((r) => {
          console.log(r.data);
          this.pdfMasivos = r.data;
          if (r.status === 200) {
            this.GenerarPdfMasivo();
          }
        });
    },

    GenerarPdfMasivo() {
      var fileURL = window.URL.createObjectURL(new Blob([this.pdfMasivos]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "ContratosFirmas.pdf");
      document.body.appendChild(fileLink);
      fileLink.click();
      this.checkeId = [];
    },

    FirmasPdfMasivo() {
      // let contadorFinalDePdf = 0;

      const arregloMasivo = [];

      for (let index of this.documentos) {
        console.log(index);
        if (index.estadoPdf) {
          console.log(index.idRenovacion);
          if (!arregloMasivo.includes(index.idRenovacion)) {
            arregloMasivo.push(index.idRenovacion);
          }
          console.log(arregloMasivo);
        }
      }

      this.axios
        .get(`RenMasivo/GenerarMasivoFirmaado/${arregloMasivo}`, {
          responseType: "blob",
        })
        .then((r) => {
          console.log(r.data);
          this.pdfMasivoFirmados = r.data;

          if (r.status == 200) {
            this.GenerarPdfMasivoFirmados();
          }
        });
    },

    GenerarPdfMasivoFirmados() {
      var fileURL = window.URL.createObjectURL(
        new Blob([this.pdfMasivoFirmados])
      );
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "ContratosFirmas.pdf");
      document.body.appendChild(fileLink);
      fileLink.click();
      this.checkeId = [];
    },

    resetPagina() {
      this.pag = 1;
      this.NUM_RESULTS = 25;
      this.noRetroceder = true;
      this.noAvanzar = this.itemsFiltrados.length <= 25;
    },

    retroceso() {
      if (this.NUM_RESULTS === 25) {
        this.noRetroceder = true;
      } else {
        this.NUM_RESULTS -= 25;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
      if (this.pag > 1) {
        this.pag--;
      }
    }
    },

    aumentar() {
      this.NUM_RESULTS += 25;
      this.pag += 1;
      if (this.NUM_RESULTS > 25) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      if (this.pag < this.totalPages) {
        this.pag++;
      }
      if (this.NUM_RESULTS >= this.itemsFiltrados.length) {
        this.noAvanzar = true;
      } else {
        this.noAvanzar = false;
      }
    }
    },



    // Ir a la primera página
    irInicio() {
      this.pag = 1;
      this.NUM_RESULTS = 25;
      this.noRetroceder = true;
      this.noAvanzar = this.itemsFiltrados.length <= 25;
    },

    // Ir a la última página
    irFinal() {
      const totalPages = this.totalPaginas;
      this.pag = totalPages;
      this.NUM_RESULTS = totalPages * 25;
      this.noAvanzar = true;
      this.noRetroceder = false;
    },
  },
};
</script>

<style scoped>
.texto-fini {
  font-size: 0.8rem;
}

.label-column {
  width: 140px;
  /* Puedes ajustar este valor según tus necesidades */
  display: inline-block;
  text-align: left;
  /* Para alinear el texto del <strong> a la derecha */
  font-size: 0.84rem;
  margin-right: 0px;
  /* Agregar un margen entre <strong> y <label> */
}

.disabled-row {
  background: #ffe5e7;
  /* opacity: 0.5; /* Cambia esto según la opacidad deseada */
  /*  pointer-events: none; */
  /* Evita la interacción con los elementos en la fila */
}

.toggle-transition {
  transition: all 0.3s ease;
  /* Cambia la duración y el tipo de transición según tus preferencias */
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 16, 16, 0.2);
  /* Fondo transparente */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  width: 60%;
  height: auto;
  background-color: #fbfbfb;
  border: 3px rgb(60, 60, 60) solid;
  padding: 0.5%;
}

input[type="text"] {
  min-width: 150px;
  padding-right: 5px;
}

select {
  width: auto;
  display: inline-block;

  text-align: center;
}

.my-custom-div {
  height: 20px;
  /* Ajusta la altura según tus necesidades */
  /* Otros estilos para el div */
}

.small-doughnut-container {
  max-width: 290px;
  /* Ajusta el ancho máximo según lo necesario */
  margin: 0;
  /* Centra el contenedor horizontalmente */
}

.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565c0;
}

.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.boton-estiloPag {
  border: 1px solid rgb(199, 199, 199);
  background-color: white;
  color: rgb(32, 32, 32);
  padding: 0.6rem 1rem;
  border-radius: 0;
}

.boton-estiloCuadrado {
  padding: 0.2rem 0.55rem;
  cursor: pointer;
  /* Cambia el cursor a una mano */
}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.tabla-estiloCompreso {
  padding: 0.3rem 0.55rem;
}

.label-resaltado {
  font-weight: 700;
  font-size: 0.65rem;
}

.tamaño {
  font-size: 0.70rem;

  font-weight: 800;
  color: #002c5d;
}
</style>
